import { FilterBodyListConfig } from '@/components/FilterNew/components/Body/types';
import {
  UseFilterValuesType,
  UseOptionsQueryParams,
  UseOptionsQueryReturnType,
} from '@/components/FilterNew/types';
import { ThemeType } from '@/types/schema';

import useFilterOptionsQuery from '../../hooks/useFilterOptionsQuery';
import useFilterValue from '../../hooks/useFilterValue';
import { useThemeFilterQuery as useQuery } from './graphql/queries/generated/themeFilter';

const edgeKey = 'themes';

const getFilterOption = (track: Pick<ThemeType, 'id' | 'name'>) => ({
  value: track.id,
  label: track.name,
});

const useFilterValues: UseFilterValuesType = ({ value }) =>
  useFilterValue({
    value,
    useQuery,
    edgeKey,
    getFilterOption,
    variables: { filters: { ids: value } },
  });

const useOptionsQuery = ({ searchText }: UseOptionsQueryParams): UseOptionsQueryReturnType =>
  useFilterOptionsQuery({
    useQuery,
    edgeKey,
    getFilterOption,
    variables: { filters: { name: searchText } },
  });

export const ThemeEntityConfig: FilterBodyListConfig = {
  listVariant: 'multi-ungrouped-infinite',
  useFilterValues,
  useOptionsQuery,
};
